import "./chunk-6F4PWJZI.js";
import { getCauses, getPreferredResolutions, getStatuses, isComplainable } from "./chunk-5EYXIXMD.js";
import { getOrderStateName, hasDeliveredArtWorkService, isOrderCancellable, isPaymentAgreed } from "./chunk-UMYTHFM4.js";
import { areSomeLineItemsCancelled, canChangeShippingAddress, getAssociatedGroupedLineItems, getAttributeDescription, getCategoryName, getDependencyFlowStartItem, getDependencyFlowStartItemState, getDependencyFlowState, getDependencyInformation, getItemOrchestration, getLineItemDescription, getLineItemStateName, getOrchestrationItemById, getOrchestrationItemByRecipient, getPickupPointHref, getRequisitesLineItemIds, getServiceGroups, hasOrchestration, hasPickupPoint, hasSplitShipment, isAnyUserArtworkNeeded, isDependencyFlowStartItem, isGroupLineItem, isLineItemCancellable, isLineItemCancelled, isLineItemEditable, isOrchestrationLineItemByRecipient, isQuoteLineItem, isReorderable, isSpecificOrchestration, isUserArtworkNeeded, orchestrations } from "./chunk-YF3G4522.js";
import { artworkRequired, hasAlternativelyUploaded, hasDocumentReferenceComplete, hasManufactureReadyArtwork, hasReviewGroup, isAlternativeUploadsUrl, isArtworkDelivered, isImage, isReviewGroupLead, isReviewedArtworkUploaded, needsArtwork } from "./chunk-2A65ZKZ4.js";
import { getProductVariantVersion, hasProductVariantVersion } from "./chunk-KFHYJPNW.js";
import { SERVICES, SERVICES_WITHOUT_USER_ARTWORK, getActiveArtworkServices, getLinkedArtworkServices, getLinkedServiceNames, getLinkedServices, getServiceName, getServiceStateName, getServices, hasActiveArtworkServiceOfTypes, hasActiveArtworkServices, hasLinkedServices, isService } from "./chunk-UWOU3UFX.js";
import { LINE_ITEM_STATES, ORDER_STATES, PAYMENT_STATES, SERVICE_ITEM_STATES, getLineItemStateIdByName, getStateNameById, getStates } from "./chunk-LW3YLJTS.js";
import { __commonJS, __glob } from "./chunk-UM5R4LAF.js";

// build/commercetools/prod/customerGroups.json
var require_customerGroups = __commonJS({
  "build/commercetools/prod/customerGroups.json"(exports, module) {
    module.exports = [{
      id: "5bf35bca-011b-432e-a9bf-67b7473cdd0e",
      name: "Top 10 reseller",
      key: "Top_10_reseller"
    }, {
      id: "a35619e8-df95-494e-9e2f-eb2560e9d251",
      name: "Resellers - Segmented pricing",
      key: "ResellersSegmentedPricing"
    }, {
      id: "2fcec44d-ea30-4a61-80a7-ab09a3280699",
      name: "MKB Groot (algemeen)",
      key: "MKBGroot"
    }, {
      id: "aa61cf3d-e62e-4e3d-88a7-59e54dfa6ed1",
      name: "Reseller Groot (Sales)"
    }, {
      id: "931df1ad-0928-46db-9b95-6a2ea9805d93",
      name: "MKB Midden (Sales)"
    }, {
      id: "8dee2563-b347-4540-9758-fcde8f39fee9",
      name: "MKB Groot (Sales)"
    }, {
      id: "884e05ea-ae55-486a-bd6c-5517cf62bfd4",
      name: "Resellers To Be Checked",
      key: "ResellersToBeChecked"
    }, {
      id: "11205e2a-e745-4543-8855-6a8839f50d01",
      name: "Quotebutton",
      key: "Quotebutton"
    }, {
      id: "8c281811-5f09-48eb-ad9d-7cc835c8f39a",
      name: "Resellers Rejected",
      key: "ResellersRejected"
    }, {
      id: "6194b38c-3b9c-456b-bb69-54b6e441a2d4",
      name: "New Business"
    }, {
      id: "26386676-12b8-46b7-ad6a-ad6f48d5d558",
      name: "Printdeal top klant"
    }, {
      id: "4d494ef1-d148-40bc-ad47-df703429b584",
      name: "TEST SEGMENTED PLUS",
      key: "TESTSEGMENTEDPLUS"
    }, {
      id: "61f6068e-4e57-40b4-bb65-937ecdaba9c2",
      name: "TEST SEGMENTED PREMIUM",
      key: "TESTSEGMENTEDPREMIUM"
    }, {
      id: "3074b7f6-ae18-40d7-8cec-be560d3f5a7a",
      name: "Basic",
      key: "ResellersSegmentedBasic"
    }, {
      id: "ac8eb776-0b20-4fe2-9829-534d66440645",
      name: "Plus",
      key: "ResellersSegmentedPlus"
    }, {
      id: "08850988-348d-4e5e-ad8d-50d73b117c4a",
      name: "Premium",
      key: "ResellersSegmentedPremium"
    }, {
      id: "2fbbeed6-b4cb-454d-bd95-c733c5bccafe",
      name: "Bronze",
      key: "EndusersSegmentedBronze"
    }, {
      id: "5bf48edb-2115-4378-8f2c-ff5a83a3c552",
      name: "Silver",
      key: "EndusersSegmentedSilver"
    }, {
      id: "ddc55b15-0768-4dc7-9c3b-2b994a4dfd8d",
      name: "Gold",
      key: "EndusersSegmentedGold"
    }, {
      id: "a1decdc9-0411-413e-af3f-a027c170f9bd",
      name: "NOT CATEGORIZED",
      key: "EndusersSegmentedNotcategorized"
    }, {
      id: "8c9a4931-4f14-4b20-ac2f-cca0575042f4",
      name: "EndUser To Be Checked",
      key: "EndUserToBeChecked"
    }, {
      id: "33a99b5e-7cc1-4c18-bc83-d1a8f4ff013f",
      name: "Enduser Exclusive",
      key: "EnduserExclusive"
    }, {
      id: "b0d26204-51b3-4e66-b31a-51ee932cfbec",
      name: "Excellent",
      key: "ResellersSegmentedExcellent"
    }, {
      id: "8dc8769f-e965-4d4b-87a6-57f4aecdf47e",
      name: "Pro",
      key: "ResellersSegmentedPro"
    }, {
      id: "bf3d33bf-8a85-4c35-899f-88a437e7156e",
      name: "Group 5",
      key: "EndusersSegmentedGroup5"
    }, {
      id: "5ec7084d-045f-48ef-ae21-ff8c573dd405",
      name: "Group 6",
      key: "EndusersSegmentedGroup6"
    }, {
      id: "dddadec7-598b-4ff8-8e12-b40f6b1bc772",
      name: "Group 7",
      key: "EndusersSegmentedGroup7"
    }, {
      id: "cb9ee01a-c6d6-428b-be43-3bdc54c9bcfd",
      name: "Endusers Rejected",
      key: "EndusersRejected"
    }];
  }
});

// build/commercetools/staging/customerGroups.json
var require_customerGroups2 = __commonJS({
  "build/commercetools/staging/customerGroups.json"(exports, module) {
    module.exports = [{
      id: "b57698bc-905c-4935-8592-8683c075023b",
      name: "Pietje",
      key: "123"
    }, {
      id: "423bddf4-f431-4d0d-8050-024774efc523",
      name: "Test",
      key: "6473"
    }, {
      id: "973a5efb-f64b-48f2-a3c4-8d75e301b36e",
      name: "B2C",
      key: "B2C"
    }, {
      id: "8edad422-2356-4355-b611-62c9e1f5fbfb",
      name: "Segmented Pricing",
      key: "segmented-pricing"
    }, {
      id: "0b0a7210-f418-440b-9356-00510c743aaf",
      name: "B2B",
      key: "B2B"
    }, {
      id: "48b15a8d-b1b6-46f5-8798-6ad1d16fa812",
      name: "Test_Rick_Discounts",
      key: "Test-rick"
    }, {
      id: "fc3570ef-a542-463b-9c3b-a9213750f5bd",
      name: "Rick - test price segmentation",
      key: "Rick-test"
    }, {
      id: "dc5d65bd-0ccd-44f1-8677-13930807869a",
      name: "Resellers To Be Checked",
      key: "ResellersToBeChecked"
    }, {
      id: "c2e4ba8c-1be0-45ee-a578-efddff579e8e",
      name: "Reseller",
      key: "Reseller"
    }, {
      id: "530b70b1-8866-4932-96e5-b79443a511a8",
      name: "Unknown",
      key: "Unknown"
    }, {
      id: "5a8b8de8-ba8e-4179-897d-09b866eed73e",
      name: "Segmented Quote group",
      key: "segmentedQuote"
    }, {
      id: "22d6db4d-3ac2-49ce-8c99-942da5037bb7",
      name: "TEST SEGMENTED PREMIUM",
      key: "TESTSEGMENTEDPREMIUM"
    }, {
      id: "81957c57-41d3-48dc-8200-dd97f22f16e8",
      name: "TEST SEGMENTED PLUS",
      key: "TESTSEGMENTEDPLUS"
    }, {
      id: "075248fe-d028-42f0-acd7-be1a5dd2f0b9",
      name: "Test Jacco",
      key: "test-jacco"
    }, {
      id: "1517a92a-1f42-496d-8a88-25b6ac948df7",
      name: "EXP355-test-group",
      key: "EXP355-test-group"
    }, {
      id: "f07cf0f9-aed1-4e4c-b826-82c71b139a3c",
      name: "Gold",
      key: "EndusersSegmentedGold"
    }, {
      id: "70ff35f7-f25e-4f1e-aa4c-25aaa15dece7",
      name: "Silver",
      key: "EndusersSegmentedSilver"
    }, {
      id: "5138ccbb-45a4-4352-8237-7195e3b26bd6",
      name: "Bronze",
      key: "EndusersSegmentedBronze"
    }, {
      id: "ceaf44f3-3d82-47db-b16c-049e0f952010",
      name: "Premium",
      key: "ResellersSegmentedPremium"
    }, {
      id: "96b960e6-b471-4d66-9f51-15ae33d8e66b",
      name: "Plus",
      key: "ResellersSegmentedPlus"
    }, {
      id: "453d6cb6-f021-4913-a94e-42c446ee196e",
      name: "Basic",
      key: "ResellersSegmentedBasic"
    }, {
      id: "9919d299-7249-4363-8453-314f47c41fa7",
      name: "Resellers - Segmented pricing",
      key: "ResellersSegmentedPricing"
    }, {
      id: "cc76fe66-e989-478e-bee2-945b792e2959",
      name: "Groep Donkervliet",
      key: "hallo-vriendjes-en-vriendinnetjes"
    }, {
      id: "40bdb04a-0377-48ed-bd1d-e06c9b10ce88",
      name: "new group",
      key: "asdasd"
    }, {
      id: "088fb417-da0a-45b3-9f85-706179ea2a54",
      name: "testing rewardswallet",
      key: "testing123"
    }, {
      id: "f29ad409-609f-41f8-a919-aa4ef6c0fc16",
      name: "Test Discounts IH",
      key: "test_discounts_IH"
    }, {
      id: "4e45cbab-840a-4453-bbf1-5767d41de7f4",
      name: "Resellers Rejected",
      key: "ResellersRejected"
    }, {
      id: "4d1ad8ee-8ad2-4c91-a56c-70355490036c",
      name: "new",
      key: "gr"
    }, {
      id: "e585016d-4f87-414b-98cc-f75f86a6bb92",
      name: "EndUser To Be Checked",
      key: "EndUserToBeChecked"
    }, {
      id: "4354c627-3ede-4f38-9998-340ba5ec8e00",
      name: "Pro",
      key: "ResellersSegmentedPro"
    }, {
      id: "2f71264e-c1a0-4518-b706-15ed07906a80",
      name: "Excellent",
      key: "ResellersSegmentedExcellent"
    }, {
      id: "eb09de79-db88-40df-aeda-1c3a63ac4b8f",
      name: "Group 5",
      key: "EndusersSegmentedGroup5"
    }, {
      id: "23eafaa4-db86-46d5-a919-3ec1a6e02388",
      name: "Group 6",
      key: "EndusersSegmentedGroup6"
    }, {
      id: "c05d8a70-2bb2-44f2-9680-256204c66af0",
      name: "Group 7",
      key: "EndusersSegmentedGroup7"
    }, {
      id: "8051b845-2281-4e1f-9a4c-cd8153f1d4fc",
      name: "Endusers Rejected",
      key: "EndusersRejected"
    }];
  }
});

// require("../build/commercetools/**/*/customerGroups.json") in src/customerGroups.ts
var globRequire_build_commercetools_customerGroups_json = __glob({
  "../build/commercetools/prod/customerGroups.json": () => require_customerGroups(),
  "../build/commercetools/staging/customerGroups.json": () => require_customerGroups2()
});

// src/customerGroups.ts
var getCustomerGroups = env => globRequire_build_commercetools_customerGroups_json("../build/commercetools/".concat(env, "/customerGroups.json"));
var getCustomerGroupNameById = (env, id) => {
  const customerGroups = getCustomerGroups(env);
  const foundCustomerGroup = customerGroups.find(customerGroup => customerGroup.id === id);
  if (foundCustomerGroup) {
    return foundCustomerGroup.name;
  }
  return null;
};

// src/customLineItem.ts
var CUSTOM_LINE_ITEM_TYPES = {
  SHIPPING: "shipping",
  ADDITIONAL_ADDRESS: "additional-address-costs",
  CUSTOMER_DISCOUNT: "customerDiscount",
  DELIVERY_SERVICE: "deliveryService",
  SERVICE: "service"
};
var hasCustomLineItemPricing = customLineItem => {
  var _a, _b, _c, _d;
  return Boolean(((_b = (_a = customLineItem.taxedPrice) == null ? void 0 : _a.totalNet) == null ? void 0 : _b.centAmount) && ((_d = (_c = customLineItem.taxedPrice) == null ? void 0 : _c.totalGross) == null ? void 0 : _d.centAmount));
};
var isCustomLineItemOfType = (customLineItem, type) => {
  var _a;
  return Boolean(((_a = customLineItem.custom) == null ? void 0 : _a.fields.lineItemType) === type);
};
var getCustomLineItemsOfType = (customLineItems, type) => customLineItems.filter(customLineItem => isCustomLineItemOfType(customLineItem, type));
var getCustomLineItemsShipping = customLineItems => getCustomLineItemsOfType(customLineItems, CUSTOM_LINE_ITEM_TYPES.SHIPPING);
var getCustomLineItemsAdditionalAddresses = customLineItems => getCustomLineItemsOfType(customLineItems, CUSTOM_LINE_ITEM_TYPES.ADDITIONAL_ADDRESS);
var getCustomLineItemsCustomerDiscount = customLineItems => getCustomLineItemsOfType(customLineItems, CUSTOM_LINE_ITEM_TYPES.CUSTOMER_DISCOUNT);
var getCustomLineItemsDeliveryService = customLineItems => getCustomLineItemsOfType(customLineItems, CUSTOM_LINE_ITEM_TYPES.DELIVERY_SERVICE);
var getCustomLineItemsFileDesign = customLineItems => customLineItems.filter(customLineItem => isCustomLineItemOfType(customLineItem, CUSTOM_LINE_ITEM_TYPES.SERVICE) && getServiceName(customLineItem) === SERVICES.FILE_DESIGN);
var getCustomLineItemsFileChange = customLineItems => customLineItems.filter(customLineItem => isCustomLineItemOfType(customLineItem, CUSTOM_LINE_ITEM_TYPES.SERVICE) && getServiceName(customLineItem) === SERVICES.FILE_CHANGE);
var getCustomLineItemsFileCheck = customLineItems => customLineItems.filter(customLineItem => isCustomLineItemOfType(customLineItem, CUSTOM_LINE_ITEM_TYPES.SERVICE) && getServiceName(customLineItem) === SERVICES.FILE_CHECK);
var getActiveCustomLineItemsService = (customLineItems, env) => customLineItems.filter(customLineItem => isCustomLineItemOfType(customLineItem, CUSTOM_LINE_ITEM_TYPES.SERVICE) && getServiceStateName(customLineItem, env) !== SERVICE_ITEM_STATES.CANCELLED);
var isActiveCustomLineItemService = (customLineItem, env) => isCustomLineItemOfType(customLineItem, CUSTOM_LINE_ITEM_TYPES.SERVICE) && getServiceStateName(customLineItem, env) !== SERVICE_ITEM_STATES.CANCELLED;

// src/deliveryTool.ts
var DELIVERY_TOOLS = {
  CHECKMATE: "checkmate",
  PRINTQ: "printqeditor",
  DESIGN_AND_PRINT: "designandprint",
  ALTERNATIVE_UPLOAD: "alternative-upload",
  UPLOADER_TOOL: "uploaderTool"
};
var getAvailableDeliveryToolsFromMRC = deliveryTool => {
  const availableDeliveryTools = [];
  if (deliveryTool.checkmate === "on" && deliveryTool.checkmatemode === DELIVERY_TOOLS.CHECKMATE) {
    availableDeliveryTools.push(DELIVERY_TOOLS.CHECKMATE);
    availableDeliveryTools.push(DELIVERY_TOOLS.UPLOADER_TOOL);
  }
  if (deliveryTool.editor === "on" && deliveryTool.editormode === DELIVERY_TOOLS.PRINTQ) {
    availableDeliveryTools.push(DELIVERY_TOOLS.PRINTQ);
  }
  if (deliveryTool.editor === "on" && deliveryTool.editormode === DELIVERY_TOOLS.DESIGN_AND_PRINT) {
    availableDeliveryTools.push(DELIVERY_TOOLS.DESIGN_AND_PRINT);
  }
  if (deliveryTool.altUploadBeforeOrder === "on" || deliveryTool.altuploadbeforeorder === "on" || deliveryTool.editormode === DELIVERY_TOOLS.ALTERNATIVE_UPLOAD) {
    availableDeliveryTools.push(DELIVERY_TOOLS.ALTERNATIVE_UPLOAD);
  }
  return availableDeliveryTools;
};
var getValidEditorTypeWithDocRef = _ref => {
  let {
    availableDeliveryTools,
    currentEditorType,
    docRef
  } = _ref;
  return {
    editorType: availableDeliveryTools.includes(currentEditorType) ? currentEditorType : availableDeliveryTools[0],
    docRef: availableDeliveryTools.includes(currentEditorType) ? docRef : null
  };
};

// src/file-validation/uploadConfig.ts
var imageUploadTypes = {
  ".jpg": "image/jpeg",
  ".jpeg": "image/jpeg",
  ".bmp": "image/bmp",
  ".tiff": "image/tiff",
  ".png": "image/png",
  ".gif": "image/gif",
  ".heic": "image/heic"
};
var fileUploadTypes = {
  ".pdf": "application/pdf",
  ".eps": "application/postscript",
  ".psd": "image/vnd.adobe.photoshop",
  ".zip": "application/x-zip-compressed",
  ".rar": "application/x-rar-compressed",
  ".7z": "application/x-7z-compressed",
  ".xls": "application/vnd.ms-excel",
  ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ".csv": "text/csv",
  ".ai": "application/postscript"
};
var imageIEUploadTypes = ["application/jpg", "application/jpeg", "application/png", "application/bmp", "application/gif", "application/tiff", "application/heic"];
var fileIEUploadTypes = ["application/postscript", "image/vnd.adobe.photoshop", "application/x-zip-compressed", "application/x-rar-compressed", "application/x-7z-compressed"];
var maxUploadSize = 1024 * 1024 * 1024;
var imageTypes = Object.values(imageUploadTypes).concat(imageIEUploadTypes);
var fileTypes = Object.values(fileUploadTypes).concat(fileIEUploadTypes);
var validationExceptions = {
  size_limit: "max_upload_size",
  filetype: "not_supported_file"
};

// src/file-validation/uploadValidator.ts
var PDF_MIME_TYPE = "application/pdf";
var getCorrectUrlFromUpload = (uploadsUrlBuilder, upload) => {
  if (imageTypes.includes(upload.type)) {
    return uploadsUrlBuilder.getImageUploadUrl();
  }
  if (fileTypes.includes(upload.type)) {
    return uploadsUrlBuilder.getFileUploadUrl();
  }
  if (Object.keys(fileUploadTypes).includes(upload.name.substring(upload.name.lastIndexOf("."), upload.name.length))) {
    return uploadsUrlBuilder.getFileUploadUrl();
  }
  if (upload.type === PDF_MIME_TYPE) {
    return uploadsUrlBuilder.getPdfUploadUrl();
  }
  return uploadsUrlBuilder.getFileUploadUrl();
};
var getFileExtensionFromFile = uploadName => uploadName.substring(uploadName.lastIndexOf("."), uploadName.length);
var isSupportedFile = upload => imageTypes.includes(upload.files[0].type) || fileTypes.includes(upload.files[0].type) || Object.keys(fileUploadTypes).includes(getFileExtensionFromFile(upload.files[0].name));

// src/file-validation/fileValidation.ts
var validateFile = file => {
  const errorMessages = [];
  if (file.size > maxUploadSize) {
    errorMessages.push(validationExceptions.size_limit);
  }
  if (!isSupportedFile({
    files: [file]
  })) {
    errorMessages.push(validationExceptions.filetype);
  }
  return errorMessages;
};

// src/apiCustomerStatus.ts
var CUSTOMER_STATUS = {
  OPEN: "open",
  IN_PROGRESS: "in-progress",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
  UNKNOWN: "unknown",
  ARTWORK_REJECTED: "artwork-rejected",
  IN_PRODUCTION: "in-production",
  SHIPPED: "shipped",
  WAITING_FOR_ARTWORK: "waiting-for-artwork",
  PROCESSING: "processing"
};
var LINE_ITEM_STATUS_MAPPING = {
  Initial: CUSTOMER_STATUS.WAITING_FOR_ARTWORK,
  Processing: CUSTOMER_STATUS.PROCESSING,
  Confirmed: CUSTOMER_STATUS.WAITING_FOR_ARTWORK,
  Cancelled: CUSTOMER_STATUS.CANCELLED,
  WaitingForArtwork: CUSTOMER_STATUS.WAITING_FOR_ARTWORK,
  WaitingForDocReview: CUSTOMER_STATUS.IN_PROGRESS,
  WaitingForSecondaryDocReview: CUSTOMER_STATUS.IN_PROGRESS,
  DocReviewInProgress: CUSTOMER_STATUS.IN_PROGRESS,
  DocReviewApproved: CUSTOMER_STATUS.IN_PROGRESS,
  DocReviewInProofing: CUSTOMER_STATUS.IN_PROGRESS,
  DocReviewFailed: CUSTOMER_STATUS.IN_PROGRESS,
  DocReviewRejected: CUSTOMER_STATUS.ARTWORK_REJECTED,
  DocFeedbackRequested: CUSTOMER_STATUS.IN_PROGRESS,
  WaitingForProposal: CUSTOMER_STATUS.IN_PROGRESS,
  ReadyForFulfillment: CUSTOMER_STATUS.IN_PROGRESS,
  FulfillmentError: CUSTOMER_STATUS.IN_PRODUCTION,
  SentToMCP: CUSTOMER_STATUS.IN_PRODUCTION,
  FulfillmentRejected: CUSTOMER_STATUS.IN_PRODUCTION,
  FulfillmentAccepted: CUSTOMER_STATUS.IN_PRODUCTION,
  PrintingInProgress: CUSTOMER_STATUS.IN_PRODUCTION,
  Shipped: CUSTOMER_STATUS.SHIPPED,
  Held: CUSTOMER_STATUS.IN_PROGRESS,
  HoldForInjection: CUSTOMER_STATUS.IN_PROGRESS,
  ProcessingCloudlabArtwork: CUSTOMER_STATUS.IN_PROGRESS,
  ProcessingCloudlabArtworkDone: CUSTOMER_STATUS.IN_PROGRESS,
  ProcessingCloudlabArtworkFailed: CUSTOMER_STATUS.IN_PROGRESS,
  PreparingDocForReview: CUSTOMER_STATUS.IN_PROGRESS,
  InStandardReview: CUSTOMER_STATUS.IN_PROGRESS
};
var ORDER_STATUS_MAPPING = {
  Open: CUSTOMER_STATUS.OPEN,
  Processing_order: CUSTOMER_STATUS.IN_PROGRESS,
  Confirmed_order: CUSTOMER_STATUS.IN_PROGRESS,
  Completed: CUSTOMER_STATUS.COMPLETED,
  Cancelled_order: CUSTOMER_STATUS.CANCELLED
};
var getLineItemCustomerStatus = stateName => {
  var _a;
  return (_a = LINE_ITEM_STATUS_MAPPING[stateName]) != null ? _a : CUSTOMER_STATUS.UNKNOWN;
};
var getOrderCustomerStatus = stateName => {
  var _a;
  return (_a = ORDER_STATUS_MAPPING[stateName]) != null ? _a : CUSTOMER_STATUS.UNKNOWN;
};
export { CUSTOMER_STATUS, CUSTOM_LINE_ITEM_TYPES, DELIVERY_TOOLS, LINE_ITEM_STATES, ORDER_STATES, PAYMENT_STATES, SERVICES, SERVICES_WITHOUT_USER_ARTWORK, SERVICE_ITEM_STATES, areSomeLineItemsCancelled, artworkRequired, canChangeShippingAddress, fileIEUploadTypes, fileTypes, fileUploadTypes, getActiveArtworkServices, getActiveCustomLineItemsService, getAssociatedGroupedLineItems, getAttributeDescription, getAvailableDeliveryToolsFromMRC, getCategoryName, getCauses, getCorrectUrlFromUpload, getCustomLineItemsAdditionalAddresses, getCustomLineItemsCustomerDiscount, getCustomLineItemsDeliveryService, getCustomLineItemsFileChange, getCustomLineItemsFileCheck, getCustomLineItemsFileDesign, getCustomLineItemsOfType, getCustomLineItemsShipping, getCustomerGroupNameById, getCustomerGroups, getDependencyFlowStartItem, getDependencyFlowStartItemState, getDependencyFlowState, getDependencyInformation, getFileExtensionFromFile, getItemOrchestration, getLineItemCustomerStatus, getLineItemDescription, getLineItemStateIdByName, getLineItemStateName, getLinkedArtworkServices, getLinkedServiceNames, getLinkedServices, getOrchestrationItemById, getOrchestrationItemByRecipient, getOrderCustomerStatus, getOrderStateName, getPickupPointHref, getPreferredResolutions, getProductVariantVersion, getRequisitesLineItemIds, getServiceGroups, getServiceName, getServiceStateName, getServices, getStateNameById, getStates, getStatuses, getValidEditorTypeWithDocRef, hasActiveArtworkServiceOfTypes, hasActiveArtworkServices, hasAlternativelyUploaded, hasCustomLineItemPricing, hasDeliveredArtWorkService, hasDocumentReferenceComplete, hasLinkedServices, hasManufactureReadyArtwork, hasOrchestration, hasPickupPoint, hasProductVariantVersion, hasReviewGroup, hasSplitShipment, imageIEUploadTypes, imageTypes, imageUploadTypes, isActiveCustomLineItemService, isAlternativeUploadsUrl, isAnyUserArtworkNeeded, isArtworkDelivered, isComplainable, isCustomLineItemOfType, isDependencyFlowStartItem, isGroupLineItem, isImage, isLineItemCancellable, isLineItemCancelled, isLineItemEditable, isOrchestrationLineItemByRecipient, isOrderCancellable, isPaymentAgreed, isQuoteLineItem, isReorderable, isReviewGroupLead, isReviewedArtworkUploaded, isService, isSpecificOrchestration, isSupportedFile, isUserArtworkNeeded, maxUploadSize, needsArtwork, orchestrations, validateFile, validationExceptions };